import React from "react";
import moment from "moment";

import { moveByCopy } from "../constants/copy";

/* eslint-disable react/prop-types */
export default ({ moveDate, searchType }) => {
  if (!moveDate || searchType === "sell" || searchType === "browse")
    return "in NYC.";

  if (searchType === "rent") {
    return (
      <>
        by <b>{moment(moveDate, "YYYY-MM-DD").format("MMM D, YYYY")}</b>.
      </>
    );
  }

  return (
    <>
      in <b>{moveByCopy[moveDate]}</b>.
    </>
  );
};
/* eslint-enable react/prop-types */
